import ApiClient, { parseRequestData } from "../utilities/http";
import { Endpoints } from "../utilities/endpoints";
import { endSubmitting, isSubmitting } from "./loadActions";
import { get } from "lodash";
import { IActivity, IActivityType, IAsset } from "../models/IAsset";
import * as actionTypes from "../actionsTypes";
import { toastError, toastSuccess } from "./formInputAction";

export const assetProbe = (code: string, skipDecode = false) => {
    return (dispatch: any) => {
        dispatch(isSubmitting({
            submitButton: true,
        }));

        ApiClient.get(Endpoints.ASSET + (!skipDecode ? '?code=' : ('?skip_decode=1&code=')) + encodeURIComponent(code))
            .then(function (response) {
                dispatch(endSubmitting({
                    submitButton: false,
                }));
                // if (get(response, 'statusText') == 'OK') {
                if ((get(response, 'statusText').toLowerCase() === 'ok') || (get(response, 'status') === 200)) {
                    const assetItem: IAsset = get(response, 'data.asset_item');
                    console.log('assetProbe, response =', response);
                    if (assetItem) {
                        return dispatch({
                            type: actionTypes.PROBE_ASSET,
                            payload: { ...assetItem }
                        });
                    } else {
                        dispatch(toastError({}, 'Unknown Scanned Asset', 'The scan code does not resolve to a known asset'))
                    }
                }
            })
            .catch(function (error) {
                dispatch(toastError(error, 'Error Fetching Asset', 'Asset could be fetched, please try again'))
            })
    }
}
